import 'date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Grid, MuiThemeProvider, createTheme } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';

import React from 'react';
import DateSelectors from './Filters/DateSelectors';
import ChannelSelectors from './Filters/ChannelSelectors';

const theme = createTheme({
  palette: {
    primary: {
      main: '#537477',
    },
  },
});

const Filters = (): JSX.Element => {
  return (
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justifyContent="space-around" alignItems="center">
          <DateSelectors />
          <ChannelSelectors />
        </Grid>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};

export default React.memo(Filters);
